import script from "./FormElements.vue?vue&type=script&lang=js"
export * from "./FormElements.vue?vue&type=script&lang=js"

import "./FormElements.vue?vue&type=style&index=0&id=0b31bf3c&lang=scss"

const __exports__ = script;

export default __exports__